module.exports = __webpack_public_path__ + "static/media/page2.31ebadff.png";